import { TextField } from "@mui/material"
import { useEffect, useState } from "react";
import { styles } from "../../../App.styles";
import { BlankLine } from "../../BlankLine/BlankLine";
import { IFormWatcherComponentProps } from "../../IFormComponentProps";
import { withLoading } from "../../withLoading";

interface IProps {
    one?: string;
}

const AssignmentWatcher: React.FC<IFormWatcherComponentProps<IProps>> = ({url, onChange, value}) => {
    const [data, setData] = useState<IProps>(value);

    useEffect(() => {
        setData(value);
    }, [value]);

    useEffect(() => {
        onChange(url, data);
    }, [data]);

    return (
        <>
            <BlankLine text="The first skill I am going to teach my dog as a mutually exclusive behaviour is:" />
            <TextField fullWidth onChange={e => setData({ ...data, one: e.target.value })} value={data.one || ''} variant="standard" InputProps={{ style: styles.blanksField}} />
        </>
    )
}

export const Day4Assignment = withLoading(AssignmentWatcher);